"use strict";
import Vue from 'vue';
import VueAppInsights from "vue-application-insights";
import router from "../router";

Vue.use(VueAppInsights, {
	id: '0063946a-a417-4a6d-903e-a3abf4b3cfca',
	router
})